module.exports = __webpack_public_path__ + "static/media/001.67c01ba8.jpg";